export default __webpack_public_path__ + "static/media/male-test.748f438e.svg";